module.exports = __webpack_public_path__ + "r-v3/img/arrow_left_gray.743112eb.svg";